// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert_Alert__1cXKT","error":"Alert_error__1XnuK","success":"Alert_success__WE7bo","info":"Alert_info__2v-Z5"};